export default __webpack_public_path__ + "static/media/whiteningLogo.356805b9.png";